import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const InvoiceBulkScheduleCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { selectedInvoiceCount = 0, invoiceBulkScheduleOptions = [] } =
        options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set recognition schedule for ${pluralizeWithCount("invoice", selectedInvoiceCount)}`}
            options={invoiceBulkScheduleOptions}
        />
    );
};
